export class Events {
    static atualizarLista:string = 'atualizarLista';
    static editar:string = 'editar';
    static copiar:string = 'copiar';
    static novo:string = 'novo';
    static visualizar:string = 'visualizar';
    static configAtualizaTipoTemplate = 'configAtualizaTipoTemplate';
}